import React, { Component } from 'react';

export default class ShortenedText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
      showLess: false,
    };
  }

  componentDidMount = () => {
    const { text } = this.props;
    if (!text) return null;
    this.showMoreTag(text);
  };

  showMoreTag = (text) => {
    const { charLimit } = this.props;
    if (text.length > charLimit) {
      this.setState({
        showMore: true,
        showLess: false,
      });
    }
  };

  showMoreText = (text) => {
    const { charLimit } = this.props;
    if (text.length > charLimit) {
      this.setState({
        showMore: !this.state.showMore,
        showLess: !this.state.showLess,
      });
    }
  };

  render() {
    const { text, charLimit, size } = this.props;
    if (!text) return null;
    const { showLess, showMore } = this.state;

    return (
      <span className={size}>
        {text.substr(0, charLimit)}
        {showMore && (
          <span
            className={`pointer lighter ${size}`}
            onClick={this.showMoreText.bind(this, text)}
          >
            ... more
          </span>
        )}
        {showLess && (
          <span className={size}>
            {text.substr(charLimit, text.length - charLimit)}
            <span
              className={`pointer lighter ${size}`}
              onClick={this.showMoreText.bind(this, text)}
            >
              {' '}
              less
            </span>
          </span>
        )}
      </span>
    );
  }
}

ShortenedText.defaultProps = {
  charLimit: 90,
  text: '',
  size: 'medium',
};
